import {http} from '@utils';
export const fetchUseGiftCode = (data: {code: string}) => {
  return http.post<null, {amount: number; code: string}>(
    '/app/exchange/code',
    data,
  );
};
